export default __webpack_public_path__ + "static/media/AddConversation.cbafd4a1.svg";